import { IOrderService, OrderService } from "@/services/order-service";
import { connect } from "react-redux";
import ViewOrderInitial from "./index";

import { Dispatch } from "@reduxjs/toolkit";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapDispatchToProps = (dispatch: Dispatch) => {
  const orderService: IOrderService = new OrderService();
  return {
    onGetDataSession: (sessionId: string): Promise<HttpResponse<any>> => {
      return orderService.fetchSessionData(sessionId).then((resp) => {
        if (resp?.data?.Token) {
          window.axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + resp.data.Token;
        }
        return resp;
      });
    },
  };
};

export default connect(null, mapDispatchToProps)(ViewOrderInitial);
